/*  DÁTUMMEZŐ: AZ ÉV UTÁN UGORJON TOVÁBB.
 *
 *  A böngésző natív dátummezője (Chrome, Edge, Electron) max nélkül 6 jegyű évet is elfogad
 *  (275760-ig), ezért a 4. számjegy után a kurzor az év-mezőben marad, és a hónapot már az
 *  évhez írná hozzá. Ha a mezőnek 4 jegyű éves `max` értéke van, a 4. számjegy után magától a
 *  hónapra lép. Az alkalmazásban kb. 170 dátummező van (sok ion-input belsejében), ezért nem
 *  egyenként állítjuk, hanem egy figyelő minden megjelenő mezőre ráteszi – ahol a sablon már
 *  megadott saját `max`-ot, azt békén hagyja. */
const MAX: Record<string, string> = { date: '9999-12-31', 'datetime-local': '9999-12-31T23:59', month: '9999-12' };

function beallit(gyoker: ParentNode) {
  gyoker.querySelectorAll?.('input[type=date]:not([max]), input[type=datetime-local]:not([max]), input[type=month]:not([max])')
    .forEach((el) => { const i = el as HTMLInputElement; i.max = MAX[i.type] || ''; });
}

export function datumMezoEvUgras() {
  if (typeof document === 'undefined' || typeof MutationObserver === 'undefined') return;
  const indit = () => {
    beallit(document);
    new MutationObserver((valtozasok) => {
      for (const v of valtozasok) {
        if (v.type === 'attributes') { const t = v.target as HTMLInputElement; if (t.tagName === 'INPUT' && MAX[t.type] && !t.max) t.max = MAX[t.type]; continue; }
        v.addedNodes.forEach((n) => {
          if (n.nodeType !== 1) return;
          const el = n as HTMLElement;
          if (el.tagName === 'INPUT') { const i = el as HTMLInputElement; if (MAX[i.type] && !i.max) i.max = MAX[i.type]; }
          else beallit(el);
        });
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['type'] });
  };
  if (document.body) indit(); else document.addEventListener('DOMContentLoaded', indit, { once: true });
}
